import { IconButton as MuiIconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const EmailIconButton = styled(MuiIconButton)(() => ({
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));
